import { render, staticRenderFns } from "./ClenchFingers1.vue?vue&type=template&id=62de1390&"
import script from "./ClenchFingers1.vue?vue&type=script&lang=js&"
export * from "./ClenchFingers1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports